export function cartItemsToOrderItems(cartItems) {
  const orderedItems = [];
  cartItems.forEach((item) => {
    console.log("item", item);
    orderedItems.push({
      name: item.title,
      qty: item.quantity,
      ingredients: [
        { sauces: item.selectedSauces },
        { salads: item.selectedSalads },
        { meats: item.selectedMeats },
        { extras: item.selectedExtras },
        { pommRice: item.selectedPommRice },
        { drink: item.selectedDrink },
      ],
      product: item.id,
    });
  });
  return orderedItems;
}
